// extracted by mini-css-extract-plugin
export var fullHeightState = "_i-7";
export var headerCell = "_i-1";
export var loadingStateCell = "_i-4";
export var rowWrapper = "_i-3";
export var standaloneTable = "_i-8";
export var standaloneTableWithBodyFill = "_i-9";
export var stateCell = "_i-5";
export var table = "_i-0";
export var tableBodyFiller = "_i-6";
export var white = "_i-2";